/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Onboarding_Height_MessageInputs */

const en_us2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I am ${i?.value} cm tall`)
};

const pt_br2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tenho ${i?.value} cm de altura`)
};

const es_419_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mido ${i?.value} cm`)
};

const pt_pt2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tenho ${i?.value} cm de altura`)
};

const fr_fr2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je mesure ${i?.value} cm`)
};

const de_de2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich bin ${i?.value} cm groß`)
};

const it_it2_onboarding_height_message = /** @type {(inputs: Onboarding_Height_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La mia altezza è ${i?.value} cm`)
};

/**
* | output |
* | --- |
* | "I am {value} cm tall" |
*
* @param {Onboarding_Height_MessageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_height_message = /** @type {((inputs: Onboarding_Height_MessageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Height_MessageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_height_message(inputs)
	if (locale === "es-419") return es_419_onboarding_height_message(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_height_message(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_height_message(inputs)
	if (locale === "de-DE") return de_de2_onboarding_height_message(inputs)
	if (locale === "it-IT") return it_it2_onboarding_height_message(inputs)
	return en_us2_onboarding_height_message(inputs)
});
export { onboarding_height_message as "onboarding.height.message" }